import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logoUrl from "@/assets/codemonk-logo-long-black.svg";

export function AuthLayout({ title, intro, children }: { title: string; intro?: ReactNode; children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col bg-surface-muted">
      <main id="main" className="flex flex-1 items-start justify-center px-4 py-12 sm:items-center">
        <div className="w-full max-w-md">
          <div className="mb-8 flex justify-center">
            <img src={logoUrl} alt={t("common.logoAlt")} width={192} height={26} className="h-7 w-auto" />
          </div>
          <div className="rounded-lg border border-border bg-surface p-6 shadow-card sm:p-8">
            <h1 className="text-2xl leading-8">{title}</h1>
            {intro ? <p className="mt-2 text-fg-muted">{intro}</p> : null}
            <div className="mt-6">{children}</div>
          </div>
        </div>
      </main>
      <footer className="flex justify-center gap-4 pb-8 text-sm">
        <Link to="/privacy" className="text-fg-muted underline">
          {t("common.footer.privacy")}
        </Link>
        <Link to="/terms" className="text-fg-muted underline">
          {t("common.footer.terms")}
        </Link>
      </footer>
    </div>
  );
}
